// biome-ignore lint/performance/noNamespaceImport: library designed for namespace import
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { cn } from '@/app_lib/utils/utils';

// NOTE: This only works for values.length === 2
export const Toggle = <T extends string>({
  disabled,
  value,
  values,
  setValue,
  className,
  'aria-label': ariaLabel = 'Filter events by time',
  'data-cy': dataCy,
}: {
  disabled: boolean;
  value: T;
  values: T[];
  setValue: (value: T) => void;
  className?: string;
  'aria-label'?: string;
  'data-cy'?: string;
}) => {
  if (values.length !== 2) {
    throw new Error('Toggle component only supports `values.length === 2`.');
  }

  return (
    <div
      className={cn(
        'relative inline-flex ring-1 ring-helper rounded-full bg-secondary p-[2px]',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
      data-cy={dataCy}
    >
      <div
        aria-hidden
        className={cn(
          'absolute inset-y-0 top-[2px] left-[3px] w-[calc(50%-3px)] h-[46.4px] lg:h-[40px] ring ring-secondary rounded-full bg-white transition-transform duration-200 ease-out',
          value === values[1] ? 'translate-x-full' : 'translate-x-0',
        )}
      />
      <ToggleGroup.Root
        aria-label={ariaLabel}
        className='relative flex gap-[2px] w-full'
        onValueChange={(v) => v && setValue(v as T)}
        type='single'
        value={value}
      >
        {values.map((v) => (
          <ToggleGroup.Item
            aria-pressed={v === value}
            className='z-10 cursor-pointer lg:leading-[100%] h-fit flex-1 flex items-center justify-center w-[calc(50%-3px)] text-center rounded-full button-h-md button-v-md font-medium text-neutral-700 transition-colors data-[state=on]:text-neutral-900 data-[state=off]:button-text-secondary-disabled hover:text-neutral-900'
            data-cy={`${v}-toggle-item`}
            disabled={disabled}
            key={`${v}-toggle-group-item`}
            value={v}
          >
            <span className='whitespace-nowrap capitalize'>{v}</span>
          </ToggleGroup.Item>
        ))}
      </ToggleGroup.Root>
    </div>
  );
};
